import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "src/componets/Buttons";
import { setEditId, ProviderInterface } from "src/store/callrecorder/providersSlice";
import { EntityId } from "@reduxjs/toolkit";
import usePermissions from "src/hooks/usePermissions";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";

import { Space, Tag } from "antd";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.callrecorder.providers.ids);
  const providers = useAppSelector(state => state.callrecorder.providers.entities);
  const count = useAppSelector(state => state.callrecorder.providers.count);
  const { write_callrecorder } = usePermissions();
  const data  = ids ? ids.map(id => providers[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const renderBoolTag = (value: boolean, trueText: string, falseText: string) => {
    return value
      ? <Tag color="success">{trueText}</Tag>
      : <Tag color="default">{falseText}</Tag>;
  }

  const columns: ColumnsType<ProviderInterface> = [
    {
      key: 'name',
      title: 'Name',
      render: (_, { name }) => <small>{name}</small>,
      width: 120,
      ellipsis: true
    },

    {
      key: 'is_active',
      title: 'Active',
      render: (_, { is_active }) => renderBoolTag(is_active, 'active', 'inactive'),
      width: 100
    },

    {
      key: 'toll_free',
      title: 'Toll Free',
      render: (_, { toll_free }) => renderBoolTag(toll_free, 'yes', 'no'),
      width: 100
    },

    {
      key: 'call_verify',
      title: 'Call Verify',
      render: (_, { call_verify }) => renderBoolTag(call_verify, 'yes', 'no'),
      width: 100
    },

    {
      key: 'blocked_destinations',
      title: 'Blocked',
      render: (_, { blocked_destinations }) => {
        if (!blocked_destinations || blocked_destinations.length === 0) return '—';
        return blocked_destinations.map(code => (
          <Tag key={code}>{code}</Tag>
        ));
      },
      width: 150
    },

    {
      key: 'inbound_sms_disabled_destinations',
      title: 'SMS In Disabled',
      render: (_, { inbound_sms_disabled_destinations }) => {
        if (!inbound_sms_disabled_destinations || inbound_sms_disabled_destinations.length === 0) return '—';
        return inbound_sms_disabled_destinations.map(code => (
          <Tag color="error" key={code}>{code}</Tag>
        ));
      },
      width: 130
    },

    {
      key: 'outgoing_sms_disabled_destinations',
      title: 'SMS Out Disabled',
      render: (_, { outgoing_sms_disabled_destinations }) => {
        if (!outgoing_sms_disabled_destinations || outgoing_sms_disabled_destinations.length === 0) return '—';
        return outgoing_sms_disabled_destinations.map(code => (
          <Tag color="error" key={code}>{code}</Tag>
        ));
      },
      width: 130
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    ...(write_callrecorder ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id }: ProviderInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
        search_keys={['name']}
        sort_keys={['created_at']}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
